export const ministries = [
  {
    title: "Salt and Light English Academy",
    description: "Teaching English and sharing the Gospel with students since 2012.",
  },
  {
    title: "Visiting Children's Homes",
    description: "Bringing hope, supplies, and encouragement to children in need.",
  },
  {
    title: "Food Distribution",
    description: "Providing food bags to families in local villages.",
  },
  {
    title: "Building Casitas",
    description: "Constructing safe, simple homes for families in need.",
  },
  {
    title: "Fixing Up Churches, Schools, and Orphanages",
    description: "Renovating and improving community spaces for lasting impact.",
  },
  {
    title: "Vacation Bible School (VBS)",
    description: "Hosting fun, faith-filled events for children and families.",
  },
  {
    title: "Ladies' and Men's Ministry",
    description: "Encouraging spiritual growth and fellowship for adults.",
  },
  {
    title: "Visiting Families We've Built For",
    description: "Following up and supporting families after projects are complete.",
  },
];